import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const actualidad = {
  state: {
    projects: [],
  },
  getters: {
    getProjects: (state) => state.projects,
    getProjectsNotfinish: (state) => {
      return state.projects.filter((e) => e.total < e.money_needed);
    },
    getProjectsfinish: (state) => {
      return state.projects.filter((e) => e.total >= e.money_needed);
    },
  },
  actions: {
    requestProyectos: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/projects/list`)
          .then((response) => {
            commit("setProjects", response.data.items);
            resolve(true);
          })
          .catch((error) => reject(error));
      });
    },
    requestProject: ({ commit }, slug) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`api/projects/show/${slug}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => reject(error));
      });
    },
  },
  mutations: {
    setProjects: (state, projects) => {
      state.projects = projects;
    },
  },
};

export default actualidad;



// WEBPACK FOOTER //
// ./src/store/projects.js